module.exports = __webpack_public_path__ + "img/6.07902295.png";